import React from "react";
import countryList from "react-select-country-list";

export type CountryOption = { value: string; label: string };

// Every country, alphabetical; value is the ISO code, label the display name
export const COUNTRIES: CountryOption[] = countryList().getData();

type CountrySelectProps = Omit<
  React.SelectHTMLAttributes<HTMLSelectElement>,
  "value" | "onChange"
> & {
  // Country name, e.g. "Nigeria"; "" when nothing is chosen
  value: string;
  onChange: (country: string) => void;
  placeholder?: string;
};

// Native select of the full country list. Callers pass their own className so
// it picks up each form's styling.
const CountrySelect: React.FC<CountrySelectProps> = ({
  value,
  onChange,
  placeholder = "Select your country",
  ...rest
}) => (
  <select {...rest} value={value} onChange={(e) => onChange(e.target.value)}>
    <option value="">{placeholder}</option>
    {COUNTRIES.map((c) => (
      <option key={c.value} value={c.label}>
        {c.label}
      </option>
    ))}
  </select>
);

export default CountrySelect;
